// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","QualityCheckboxes":"ex_a bhy_j bhy_i bhy_bc bhy_r bhy_st","QualityCheckboxes__quality":"ex_b"};